import axios from 'axios';

type ImageVariant =
  | '640x480'
  | '768x576'
  | '1024x768'
  | '1280x960'
  | '1600x1200'
  | 'logo'
  | 'promo';

export async function upload_image(
  entity:
    | 'venue'
    | 'venue-space'
    | 'service-provider'
    | 'service-category'
    | 'contact',
  type: 'gallery' | 'logo' | 'single',
  entity_id: string,
  file: File,
  lexorank?: string
) {
  const url_response = await axios.post('/api/image/signed-url', {
    entity,
    entity_id,
    type,
  });

  const { id, uploadURL } = url_response.data;

  const formData = new FormData();
  formData.append('file', file);

  await axios.post(uploadURL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const { data } = await axios.post(`/api/${entity}/${entity_id}/image`, {
    image_id: id,
    type,
    lexorank,
  });

  return data;
}

export function delete_image(image_id: string) {
  return axios.delete(`/api/image/${image_id}`);
}

export function update_image_lexorank(image_id: string, lexorank: string) {
  return axios.patch(`/api/image/${image_id}`, {
    lexorank,
  });
}

export function convertImageIDToURL(
  image_id: string,
  variant: ImageVariant = '640x480'
) {
  return `https://imagedelivery.net/s7YIdaKmqJBCctzTZ8Z0Eg/${image_id}`;
  // return `https://www-prod.vsinfra.xyz/cdn-cgi/imagedelivery/s7YIdaKmqJBCctzTZ8Z0Eg/${image_id}/${variant}`;
}
